import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui-kit/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui-kit/dialog';
import type { PurchaseCompleteMessage } from '../purchase-complete.contract';

interface PurchaseCompleteDialogProps {
  open: boolean;
  payload: PurchaseCompleteMessage | null;
  onClose: () => void;
}

export const PurchaseCompleteDialog = ({ open, payload, onClose }: PurchaseCompleteDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="!max-w-[400px]">
        <div className="flex flex-col items-center text-center gap-3 pt-1">
          <div className="h-12 w-12 rounded-full bg-lime-green/10 flex items-center justify-center">
            <CheckCircle2 className="h-7 w-7 text-poly-green" />
          </div>
          <DialogHeader className="!p-0 !space-y-1 !text-center sm:!text-center items-center">
            <DialogTitle>
              {t('PURCHASE_COMPLETE_TITLE', { defaultValue: 'Purchase complete' })}
            </DialogTitle>
            <DialogDescription>
              {t('PURCHASE_COMPLETE_BODY', {
                defaultValue: 'Your package is now active. You can continue working in Legal Templates.',
              })}
            </DialogDescription>
          </DialogHeader>
          {payload?.purchasedAt ? (
            <p className="text-xs text-globe-grey">
              {new Date(payload.purchasedAt).toLocaleString()}
            </p>
          ) : null}
          <Button className="mt-1 w-full" onClick={onClose}>
            {t('PURCHASE_COMPLETE_DONE', { defaultValue: 'Done' })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
